module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-24.dcb51202.png";